import { render, staticRenderFns } from "./BillingLocationBenefitsModal.vue?vue&type=template&id=51572597&scoped=true&"
import script from "./BillingLocationBenefitsModal.vue?vue&type=script&lang=ts&"
export * from "./BillingLocationBenefitsModal.vue?vue&type=script&lang=ts&"
import style0 from "./BillingLocationBenefitsModal.vue?vue&type=style&index=0&id=51572597&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51572597",
  null
  
)

export default component.exports